import { Button } from "@mui/material";

const ConfirmButton = ({ label, onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "#16a34a",
        "&:hover": {
          backgroundColor: "#166534",
        },
      }}>
      {label}
    </Button>
  );
};

export default ConfirmButton;
